import React, { createContext, useState } from "react";

export const HomeContext = createContext();

export function HomeProvider({ children }) {
  const [banners, setBanners] = useState();
  const [howItWorksSection, setHowItWorksSection] = useState();
  const [plansSection, setPlansSection] = useState();
  const [doubtsSection, setDoubtsSection] = useState();


  return (
    <HomeContext.Provider
      value={{
        banners,
        setBanners,
        howItWorksSection,
        setHowItWorksSection,
        plansSection,
        setPlansSection,
        doubtsSection,
        setDoubtsSection,
      }}
    >
      {children}
    </HomeContext.Provider>
  );
}